import React, {useState} from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';


import {
    Button, Grid, Popover, makeStyles
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { exportAnalysesAsync, clearAnalysis } from '../../../../../redux/analysis/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSiteCardsFromFeatureAnalysesAsync } from '../../../../../redux/site_card/Actions';
import AnalysisCreateDialog from "./AnalysisCreateDialog"


const useStyles = makeStyles((theme) => ({
    typography: {
      padding: theme.spacing(2),
    },
    moreButton: {
        minWidth: "auto"
    }
  }));
  
export function MoreOptionsPopover({resultSet, selectedFeatures, handleExportClick}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
  
    return (
      <div>
        <Button 
            className={classes.moreButton} 
            fullWidth
            variant="contained"
            aria-describedby={id} 
            color="secondary" 
            onClick={handleClick}
            disabled={!resultSet || resultSet.status !== 'complete' || selectedFeatures.length === 0}
        >
          <MoreVertIcon />
        </Button>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <Button
                variant="contained"
                size="large"
                // color="secondary"
                disabled={!resultSet || resultSet.status !== 'complete' || selectedFeatures.length === 0}
                onClick={handleExportClick}
            >
                Export as csv
            </Button>
        </Popover>
      </div>
    );
  }

class AnalysisActions extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        resultSet: PropTypes.object,
        selectedFeatures: PropTypes.arrayOf(PropTypes.number).isRequired,
        // Redux Dispatch
        dispatchSaveSiteCardsFromFeatureAnalyses: PropTypes.func.isRequired,
        dispatchExportAnalysesAsync: PropTypes.func.isRequired,
        dispatchClearAnalysis: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isCreateSiteCardDialogOpen: false
        }

        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);      
    }

    handleSaveClick () {
        const { selectedFeatures, dispatchSaveSiteCardsFromFeatureAnalyses, projectStructure } = this.props;
        projectStructure.columnOrder.length > 1 ? this.setState({isCreateSiteCardDialogOpen: true}) : dispatchSaveSiteCardsFromFeatureAnalyses(selectedFeatures)
    }

    handleExportClick () {
        const { selectedFeatures, resultSet, dispatchExportAnalysesAsync } = this.props;
        if (resultSet) { dispatchExportAnalysesAsync(resultSet.id, selectedFeatures); }
    }

    handleBackClick () {
        const { dispatchClearAnalysis } = this.props;
        dispatchClearAnalysis();
    }

    // Should be feature check for been able to save site cards and for exporting csv
    // CSV should hit backend, auth, then backend should return csv rather than frontend
    // Potentially save copy of csv as user resource during that backend request?

    render () {
        const { classes, resultSet, selectedFeatures, projectStructure } = this.props;        
        return (
            <div className={classes.actions}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Button
                            variant="outlined"
                            size="large"
                            color="secondary"
                            fullWidth
                            onClick={this.handleBackClick}
                        >
                            Back
                        </Button>
                    </Grid>
                    <Grid item xs={7}>
                        <Button
                            variant="contained"
                            size="large"
                            color="secondary"
                            fullWidth
                            disabled={selectedFeatures.length === 0}
                            onClick={this.handleSaveClick}
                        >
                            Save sites
                        </Button>
                    </Grid>
                    <Grid item xs={1}>
                        <MoreOptionsPopover 
                            resultSet={resultSet} 
                            selectedFeatures={selectedFeatures} 
                            handleExportClick={this.handleExportClick}
                        />
                    </Grid>
                </Grid>
                <AnalysisCreateDialog
                    open={this.state.isCreateSiteCardDialogOpen}
                    onClose={() => this.setState({isCreateSiteCardDialogOpen: false})}
                    projectStructure={projectStructure}
                    selectedFeatures={selectedFeatures}
                />
            </div>

        );
    }
}

const style = theme => ({
    actions: {
        display: 'flex',
        '& > *': {
            flexGrow: 1,
            '&:not(:last-child)': {
                marginRight: theme.constants.spacing.xl
            }
        }
    }
});

const mapStateToProps = state => {
    return {
        resultSet: state.analysis.analysis,
        selectedFeatures: state.analysis.selectedFeatures,        
        projectStructure: state.project.currentProject.structure
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSaveSiteCardsFromFeatureAnalyses: (ids) => dispatch(createSiteCardsFromFeatureAnalysesAsync(ids)),
    dispatchExportAnalysesAsync: (id, ids) => dispatch(exportAnalysesAsync(id, ids)),
    dispatchClearAnalysis: () => dispatch(clearAnalysis())
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(AnalysisActions);